// Fabric.js custom vector EPS object
fabric.VectorPlaceholder = fabric.util.createClass(fabric.Group, {
    async: true,
    type: 'vector-placeholder',
    cacheProperties: fabric.Group.prototype.cacheProperties.concat('stroke'),

    originX: 'center',
    originY: 'center',
    selectedPosition: 1,
    svgColor: '',

    svgString: '',
    pdf: null,

    rotationStep: 1,
    coverMaskArea: false,
    lockUniScalingWithSkew: false,

    preventEditMode: false,
    _editMode: false,
    _enablingEditMode: false,
    _editModeDataBackup: {},

    _boundingBoxOffsetX: 0,
    _boundingBoxOffsetY: 0,

    initialize: function (options) {
        const scope = this;
        options.width = options.width || 300;
        options.height = options.height || 300;

        const boundsRectangle = new fabric.Rect({
            strokeDashArray: options.strokeDashArray || [10, 10],
            originX: 'center',
            originY: 'center',
            stroke: options.stroke || '#000000',
            strokeWidth: options.strokeWidth || 0,
            width: options.width,
            height: options.height,
            fill: 'rgba(0, 0, 0, 0)',
            id: options.id
        });

        // Create the rectangle used to move the vector around in edit mode
        const isMobile = !!options.isMobile;
        this._controlRectangle = new fabric.Rect({
            originX: 'center',
            originY: 'center',
            strokeWidth: 3,
            width: options.width,
            height: options.height,
            fill: 'rgba(0, 0, 0, 0)',
            id: options.id
        });

        this._controlRectangle.setControlsVisibility({
            tl: !isMobile,
            tr: !isMobile,
            br: !isMobile,
            bl: !isMobile,
            mtr: !isMobile,

            ml: false,
            mb: false,
            mr: false,
            mt: false
        });

        this.callSuper(
            'initialize',
            [
                new fabric.SVGObject({
                    width: options.width,
                    height: options.height,
                    visible: true,
                    originX: 'center',
                    originY: 'center'
                }),
                new fabric.PDFObject({
                    width: options.width,
                    height: options.height,
                    visible: false,
                    originX: 'center',
                    originY: 'center'
                }),
                boundsRectangle
            ],
            options
        );

        // Center the bound rectangle in the group
        boundsRectangle.set('left', 0);
        boundsRectangle.set('top', 0);
        boundsRectangle.setCoords();
        this._resetControlRectangle();

        this._controlRectangle.on({
            mousedown: function (e) {
                scope.canvas.fire('object:placeholder:mousedown');
            },
            mouseup: function (e) {
                scope.canvas.fire('object:placeholder:mouseup');
            },
            selected: function (e) {
                scope.canvas.fire('object:placeholder:maskSelected');
            },
            deselected: function (e) {
                scope.fire('deselected', e);
            },
            moving: function () {
                const distanceX = this.left - scope.left;
                const distanceY = this.top - scope.top;
                scope.setVectorOffset(distanceX, distanceY);
            },
            rotating: function () {
                // Rotate the element in steps
                this.angle = Math.ceil(this.angle / scope.rotationStep) * scope.rotationStep;
                scope.setVectorAngle(this.angle - scope.angle);
            },
            scaling: function () {
                scope.setVectorScale(this.scaleX, this.scaleY);
            }
        });

        this.on({
            added: function () {
                this.cornerSize = 0.025 * this.canvas.width;
            },
            removed: function () {
                this.canvas.remove(this._controlRectangle);
            },
            scaling: function (event) {
                // Only allow proportional scaling but allowing skew
                if (this.lockUniScalingWithSkew) {
                    let scale = 1;
                    if (event.transform.action === 'scaleX') {
                        scale = this.scaleX;
                    } else {
                        scale = this.scaleY;
                    }

                    this.scaleX = scale;
                    this.scaleY = scale;
                }
            },
            scaled: function () {
                this.setScale(this.width, this.height);
            },
            rotated: function () {
                this._resetControlRectangle();
            },
            'object:dblclick': function () {
                if (!this.preventEditMode) {
                    this._editMode = true;
                    this._enablingEditMode = true;

                    // Disable canvas selection
                    this._editModeDataBackup.originalCanvasSelection = this.canvas.selection;
                    this.canvas.selection = false;

                    // Make sure we can't use the controls when the mouse is over even when they are
                    //  not drawn
                    this._editModeDataBackup.controlsVisibilityBackup = JSON.parse(
                        JSON.stringify(this._getControlsVisibility())
                    );
                    this.setControlsVisibility({
                        bl: false,
                        br: false,
                        mb: false,
                        ml: false,
                        mr: false,
                        mt: false,
                        mtr: false,
                        tl: false,
                        tr: false
                    });

                    // Match selection settings
                    this._controlRectangle.set('cornerSize', this.cornerSize);
                    this._controlRectangle.set('transparentCorners', this.transparentCorners);
                    this._controlRectangle.set('centeredScaling', true);
                    this._controlRectangle.set('centeredRotation', true);
                    this._controlRectangle.set('skewX', this.skewX);
                    this._controlRectangle.set('skewY', this.skewY);

                    let scaleX = this.item(0).visible ? this.item(0).scaleX : this.item(1).scaleX;
                    let scaleY = this.item(0).visible ? this.item(0).scaleY : this.item(1).scaleY;
                    this._controlRectangle.set('scaleX', scaleX);
                    this._controlRectangle.set('scaleY', scaleY);

                    // Select the bounding rectangle object
                    this.canvas.add(this._controlRectangle);
                    this.canvas.setActiveObject(this._controlRectangle);

                    // Block object movement
                    this._editModeDataBackup.originalLockX = this.lockMovementX;
                    this._editModeDataBackup.originalLockY = this.lockMovementY;
                    this.lockMovementX = this.lockMovementY = true;

                    if (!this.silentEditMode) {
                        // Make the stroke red
                        this._editModeDataBackup.originalStroke = this.item(2).stroke;
                        this._editModeDataBackup.originalStrokeWidth = this.item(2).strokeWidth;

                        this.item(2).set('stroke', 'red');
                        this.item(2).set('strokeWidth', 5);
                    }

                    this._enablingEditMode = false;
                    this.canvas.requestRenderAll();
                }
            },
            deselected: function () {
                // When edit mode was forced (calling enableEditMode()) don't disable edit mode
                //  on deselection
                if (this._editMode && !this._forcedEditMode && !this._enablingEditMode) {
                    this._editMode = false;
                    this.canvas.selection = this._editModeDataBackup.originalCanvasSelection;
                    this.canvas.remove(this._controlRectangle);

                    // Restore controls
                    this.setControlsVisibility(this._editModeDataBackup.controlsVisibilityBackup);

                    // Restore movement lock
                    this.lockMovementX = this._editModeDataBackup.originalLockX;
                    this.lockMovementY = this._editModeDataBackup.originalLockY;

                    if (!this.silentEditMode) {
                        this.item(2).set('stroke', this._editModeDataBackup.originalStroke);
                        this.item(2).set('strokeWidth', this._editModeDataBackup.originalStrokeWidth);
                        this.set('dirty', true);
                    }

                    this.canvas.renderAll();
                }
            }
        });

        this._adjustClippingPath();
    },

    _set: function (key, value) {
        if (key === 'id') {
            if (this._controlRectangle) {
                this._controlRectangle.id = value;
            }
            this.callSuper('_set', key, value);
        } else if (key === 'coverMaskArea') {
            this.item(0).set('coverMaskArea', value);
            this.item(1).set('coverMaskArea', value);
            this.callSuper('_set', key, value);
        } else if (key === 'angle') {
            this.callSuper('_set', key, value);
            this._resetControlRectangle();
        } else if (key === 'svgString') {
            this.setSVGString(value);
            this._resetControlRectangle();
        } else if (key === 'svgImage') {
            this.setSvgImage(value);
            this._resetControlRectangle();
        } else if (key === 'pdf') {
            const pdfObj = this.item(1);
            const svgObj = this.item(0);

            pdfObj.set('visible', true);
            svgObj.set('visible', false);

            pdfObj.set('pdf', value);
            this.pdf = value;
            this.svgString = '';
            this._resetControlRectangle();
            this._updateSelectionRectScale(pdfObj._renderPromise, pdfObj);
        } else if (key === 'width') {
            value = value || 0;

            // Set new dimensions
            this._objects.forEach((element) => {
                element.set('width', value);
                element.setCoords();
            });

            this.callSuper('_set', key, value);
            this._adjustClippingPath();
            this._resetControlRectangle();
        } else if (key === 'height') {
            value = value || 0;

            // Set new dimensions
            this._objects.forEach((element) => {
                element.set('height', value);
                element.setCoords();
            });

            this.callSuper('_set', key, value);
            this._adjustClippingPath();
            this._resetControlRectangle();
        } else if (key === 'svgColor') {
            this.item(0).set('svgColor', value);
            this.item(1).set('pdfColor', value);
            this.callSuper('_set', key, value);
        } else if (key === 'evented') {
            this._controlRectangle.set('evented', value);

            // If on edit mode, don't alter the evented attribute from the VectorPlaceholder, only from the
            //  selection rectangle
            if (!this._forcedEditMode && !this._editMode) {
                this.callSuper('_set', key, value);
            }
        } else if (key === 'stroke' || key === 'strokeWidth') {
            this.item(2).set(key, value);
            this.callSuper('_set', key, value);
        } else if (key === 'hasControls') {
            this._controlRectangle.set('hasControls', value);
            this.callSuper('_set', key, value);
        } else {
            this.callSuper('_set', key, value);
        }
    },

    /**
     * This enables edit mode to allow moving and zooming the vector within the element.
     * The only way to disable edit mode after using enableEditMode() is calling
     *  disableEditMode()
     */
    enableEditMode: function () {
        this._forcedEditMode = true;
        this.fire('object:dblclick');
    },

    disableEditMode: function () {
        this.fire('deselected');
    },

    /**
     * This method is intended to be called after the object was modified with a group
     *  selection. On fabric.js, elements events are not fired when inside a group, that's
     *  why this method must be called manually after exiting group selection
     */
    updateFromGroupScaling: function () {
        this.setScale(this.width, this.height);
    },

    setScale: function (width, height) {
        const w = width * this.scaleX,
            h = height * this.scaleY;

        // Set the new width and height
        this.scaleX = 1;
        this.scaleY = 1;
        this.set({ width: w, height: h });
    },

    setSvgImage: function (image) {
        this.item(1).set('visible', false);
        this.item(0).set('visible', true);

        this.item(0).set('svgImage', image);
        this.pdf = null;
        this.svgString = '';
        this._updateSelectionRectScale(this.item(0)._renderPromise, this.item(0));
    },

    setSVGString: function (svg) {
        this.item(1).set('visible', false);
        this.item(0).set('visible', true);

        this.item(0).set('svgString', svg);
        this.pdf = null;
        this.svgString = svg;
        this._updateSelectionRectScale(this.item(0)._renderPromise, this.item(0));
    },

    setVectorOffset(offsetX, offsetY) {
        const result = this._correctOffset(offsetX, offsetY);

        this.item(0).set('left', result.x);
        this.item(1).set('left', result.x);

        this.item(0).set('top', result.y);
        this.item(1).set('top', result.y);

        this._controlRectangle.set('left', this.left + offsetX);
        this._controlRectangle.set('top', this.top + offsetY);
        this._controlRectangle.setCoords();
    },

    setVectorAngle(angle) {
        this.item(0).set('angle', angle);
        this.item(1).set('angle', angle);

        this._controlRectangle.set('angle', angle + this.angle);
        this._controlRectangle.setCoords();
    },

    setVectorScale(scaleX, scaleY) {
        this.item(0).set('scaleX', scaleX);
        this.item(1).set('scaleX', scaleX);

        this.item(0).set('scaleY', scaleY);
        this.item(1).set('scaleY', scaleY);

        this._controlRectangle.set('scaleX', scaleX);
        this._controlRectangle.set('scaleY', scaleY);
        this._controlRectangle.setCoords();
    },

    getEditModeParameters() {
        return {
            offsetX: this._controlRectangle.left - this.left || 0,
            offsetY: this._controlRectangle.top - this.top || 0,
            scaleX: this._controlRectangle.scaleX || 1,
            scaleY: this._controlRectangle.scaleY || 1,
            angle: this._controlRectangle.angle || 0
        };
    },

    _updateSelectionRectScale: function (promise, item) {
        if (promise) {
            promise.then(() => {
                this._controlRectangle.set('scaleX', item.scaleX);
                this._controlRectangle.set('scaleY', item.scaleY);
                this._controlRectangle.setCoords();
            });
        }
    },

    /**
     * Compute the corrected X and Y displacement with the current object angle. Lots of math to
     *  end up with this equations, I can't add a picture of all the math I did but should be pretty
     *  straightforward to calculate them again if needed.
     *
     * @param {number} offsetX translation in the X axis
     * @param {number} offsetY translation in the Y axe
     */
    _correctOffset: function (offsetX, offsetY) {
        // Convert canvas coordinate to group relative coordinates
        const mGroup = this.calcTransformMatrix(true);
        const mCanvasObject = fabric.iMatrix;
        const mTotal = fabric.util.multiplyTransformMatrices(mGroup, mCanvasObject);
        const mInverse = fabric.util.invertTransform(mTotal);
        const result = fabric.util.transformPoint(new fabric.Point(this.left + offsetX, this.top + offsetY), mInverse);
        return result;
    },

    _resetControlRectangle: function () {
        const rect = this._controlRectangle;
        rect.set('left', this.left);
        rect.set('top', this.top);
        rect.set('angle', this.angle);
        rect.set('scaleX', 1);
        rect.set('scaleY', 1);
        rect.set('width', this.width);
        rect.set('height', this.height);

        this.setVectorOffset(0, 0);
        this.setVectorAngle(0);
        this.setVectorScale(1, 1);
    },

    _adjustClippingPath: function () {
        if (!this.clipPath) {
            this.set(
                'clipPath',
                new fabric.Rect({
                    originX: 'center',
                    originY: 'center'
                })
            );
        }

        this.clipPath.set('width', this.width);
        this.clipPath.set('height', this.height);
    },

    _getPdfRenderPromise: function () {
        var pdfObj = this.item(1);
        return pdfObj._renderPromise;
    },

    _getSvgRenderPromise: function () {
        var svgObj = this.item(0);
        return svgObj._renderPromise;
    },

    toObject: function (propertiesToInclude) {
        const additionalProperties = [
            'id',
            'uuid',
            'strokeWidth',
            'strokeDashArray',
            'centeredRotation',
            'selectedPosition',
            'selectedColorPosition',
            'vectors',
            'colors',
            'vectorLibraryId',
            'colorLibraryId',
            'skewX',
            'skewY',
            'lockUniScalingWithSkew',
            'evented',
            'selectable',
            'visible',
            'locked',
            'name',
            'coverMaskArea',
            'rotationStep',
            'cornerSize',
            'transparentCorners',
            'zIndex',
            'allowUserUpload',
            'applyColoring',
            'svgString',
            'svgColor',
            'groupId',
            'pageEpsId',
            'starMapConfig',
            'qrConfig',
            'type',
            'allowEdit',
            'isSolidBackground'
        ].concat(propertiesToInclude);

        return this.callSuper('toObject', additionalProperties);
    }
});

fabric.VectorPlaceholder.fromObject = function (object, callback) {
    object.clipPath = undefined;
    const newObject = new fabric.VectorPlaceholder(object);
    callback(newObject);
};
